import { useEffect } from "react";
import Lenis from "lenis";
import { gsap, ScrollTrigger, prefersReducedMotion } from "./gsap";

// Weighted smooth scroll for public pages only, driven by GSAP's ticker so
// ScrollTrigger pins and scrubs stay in sync. Skipped for reduced motion.
function SmoothScroll() {
    useEffect(() => {
        if (prefersReducedMotion()) return;

        const lenis = new Lenis({ duration: 1.15, easing: (t) => 1 - Math.pow(1 - t, 4) });
        lenis.on("scroll", ScrollTrigger.update);
        const tick = (time) => lenis.raf(time * 1000);
        gsap.ticker.add(tick);
        gsap.ticker.lagSmoothing(0);

        return () => {
            gsap.ticker.remove(tick);
            gsap.ticker.lagSmoothing(500, 33);
            lenis.destroy();
        };
    }, []);

    return null;
}

export default SmoothScroll;
